import React, { useRef, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import md5 from "crypto-js/md5";
import { useSessionStore } from "../../../../Stores/SessionStore";
import GradientButton from "../../../Core/GradientButton";
import OneVoucherLogo from "../../../../Images/1Voucher.svg";
import OneVoucherModal from "./OneVoucherModal";
import FlashLogo from "../../../../Images/FlashLogo.png";
import FlashAccountPaymentModal from "./FlashAccountPaymentModal";

export default function Confirmation(props) {
	const store = useSessionStore();
	const navigate = useNavigate();
	const formRef = useRef(null);

	const [showOneVoucherModal, setShowOneVoucherModal] = useState(false);
	const [showFlashPaymentModal, setShowFlashPaymentModal] = useState(false);
	const [creatingPaymentRequest, setCreatingPaymentRequest] = useState(false);
	const [voucherCode, setVoucherCode] = useState("");
	const [voucherCodeErrorMessage, setVoucherCodeErrorMessage] = useState("");
	const [voucher, setVoucher] = useState(null);
	const [showDiscountControls, setShowDiscountControls] = useState(false);
	const [itnAmount, setItnAmount] = useState(props.product.Price);
	const [completingPurchase, setCompletingPurchase] = useState(false);

	function getHashValue(value) {
		return encodeURIComponent(value.trim()).replace(/%20/g, "+");
	}

	function removeInvalidCharacters(value) {
		return value.replace("'", "");
	}

	function getHash() {
		let hashInput =
			`merchant_id=${getHashValue(store.Config.payfastMerchantId)}&` +
			`merchant_key=${getHashValue(store.Config.payfastMerchantKey)}&` +
			`return_url=${getHashValue(store.Config.payfastSuccessUrl)}&` +
			`cancel_url=${getHashValue(store.Config.payfastCancelUrl)}&` +
			`notify_url=${getHashValue(store.Config.payfastNotifyUrl)}&` +
			`name_first=${getHashValue(removeInvalidCharacters(store.Session.Customer.FirstName))}&` +
			`name_last=${getHashValue(removeInvalidCharacters(store.Session.Customer.Surname))}&` +
			`email_address=${getHashValue(store.Session.Customer.Email)}&` +
			`amount=${getHashValue(itnAmount.toFixed(2))}&` +
			`item_name=${getHashValue(`${props.category} ${props.product.Name} Access`)}&` +
			`custom_str1=${props.product.Id}&` +
			`custom_str2=${store.Session.Customer.Id}&` +
			`custom_str3=${voucher ? voucher.Id : ""}&` +
			`custom_str4=&`;

		if (!props.isNotSubscription && props.product.Period === 31) {
			hashInput += `subscription_type=1&`;
			hashInput += `recurring_amount=${getHashValue(itnAmount.toFixed(2))}&`;
			hashInput += `frequency=3&`;
			hashInput += `cycles=0&`;
		}

		hashInput += `passphrase=${getHashValue(store.Config.payfastPassphrase)}`;
		return md5(hashInput);
	}

	async function onOnlineSubmit(e) {
		e.preventDefault();
		setCreatingPaymentRequest(true);

		try {
			await store.PaymentRequestsService.CreatePaymentRequest(props.product.Id);
		} catch (exception) {
			// payment request creation is best-effort before redirect
		}

		setCreatingPaymentRequest(false);
		formRef.current.submit();
	}

	function handleVoucherCodeChange(e) {
		setVoucherCode(e.target.value);
	}

	async function handleApplyVoucherCode() {
		if (!voucherCode) return;

		const results = await store.VouchersService.VerifyVoucherCode(store.Session.Customer.Id, voucherCode);
		if (results && results.Success) {
			if (results.Data.Status === 1) {
				const value = results.Data.VoucherValue;
				let newItnAmount = props.product.Price - value;
				if (newItnAmount < 0) {
					newItnAmount = 0;
				}
				setItnAmount(newItnAmount);
				setVoucher(results.Data);
				setVoucherCodeErrorMessage("");
			} else {
				setVoucher(null);
				setVoucherCodeErrorMessage("Invalid voucher.");
			}
		} else {
			setVoucher(null);
			setVoucherCodeErrorMessage(results?.Message ?? "Invalid voucher.");
		}
	}

	async function handleCompletePurchase() {
		setCompletingPurchase(true);
		const result = await store.RechargesService.CreateRechargeFromVoucher(
			store.Session.Customer.Id,
			props.product.Id,
			voucher.Id
		);

		if (result && result.Success) {
			navigate("/Portal/Home");
		}
		setCompletingPurchase(false);
	}

	const oneVoucherDisabled = !props.isNotSubscription && props.product.Period === 31;
	const flashPaymentDisabled = oneVoucherDisabled;

	return (
		<React.Fragment>
			<Row>
				<Col className="text-center">
					{props.product.Period === 31 && props.isNotSubscription && (
						<p>You selected a once-off monthly package using other payment options.</p>
					)}
					{props.product.Period === 31 && !props.isNotSubscription && (
						<>
							<p>Please note that a recurring subscription only supports the use of a credit or cheque card.</p>
							<p>Your subscription will renew every month until you cancel it.</p>
						</>
					)}
					{props.product.Period !== 31 && <p>Please verify you would like to add the following voucher:</p>}
					<p className="font-weight-bold">
						{props.category} {props.product.Name} Access (R {itnAmount.toFixed(0)})
					</p>
				</Col>
			</Row>
			{props.product.Period === 1 && (
				<Row>
					<Col className="text-center">
						<label className="form-check-label text-danger fw-bold">
							Please Note: THIS PACKAGE EXPIRES THE SAME DAY OF PURCHASE.
						</label>
					</Col>
				</Row>
			)}

			<div className="pl-3 pr-3 pl-md-0 pr-md-0">
			<Form ref={formRef} action={`${store.Config.payfastUrl}process`} method="post" onSubmit={onOnlineSubmit}>
				<Row className="pt-4">
					<input type="hidden" name="merchant_id" value={store.Config.payfastMerchantId} />
					<input type="hidden" name="merchant_key" value={store.Config.payfastMerchantKey} />
					<input type="hidden" name="return_url" value={store.Config.payfastSuccessUrl} />
					<input type="hidden" name="cancel_url" value={store.Config.payfastCancelUrl} />
					<input type="hidden" name="notify_url" value={store.Config.payfastNotifyUrl} />
					<input type="hidden" name="name_first" value={removeInvalidCharacters(store.Session.Customer.FirstName)} />
					<input type="hidden" name="name_last" value={removeInvalidCharacters(store.Session.Customer.Surname)} />
					<input type="hidden" name="email_address" value={store.Session.Customer.Email} />
					<input type="hidden" name="amount" value={itnAmount.toFixed(2)} />
					<input type="hidden" name="item_name" value={`${props.category} ${props.product.Name} Access`} />
					<input type="hidden" name="custom_str1" value={props.product.Id} />
					<input type="hidden" name="custom_str2" value={store.Session.Customer.Id} />
					<input type="hidden" name="custom_str3" value={voucher ? voucher.Id : ""} />
					<input type="hidden" name="custom_str4" value="" />

					{!props.isNotSubscription && props.product.Period === 31 && (
						<React.Fragment>
							<input type="hidden" name="subscription_type" value="1" />
							<input type="hidden" name="recurring_amount" value={itnAmount.toFixed(2)} />
							<input type="hidden" name="frequency" value="3" />
							<input type="hidden" name="cycles" value="0" />
						</React.Fragment>
					)}

					<input type="hidden" name="signature" value={getHash()} />
					{itnAmount > 0 ? (
						<>
							<Col xs={12} md={4}>
								<GradientButton
									title={creatingPaymentRequest ? "Online Payment..." : "Online Payment"}
									variant="greenYellow"
									type="submit"
									disabled={creatingPaymentRequest}
									loading={creatingPaymentRequest}
									className="mb-3"
								/>
							</Col>
							<Col xs={12} md={4}>
								<GradientButton
									variant="greenYellow"
									onClick={() => setShowOneVoucherModal(true)}
									disabled={oneVoucherDisabled}
									aria-label="1Voucher"
									style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
									className="mb-3"
								>
									<img src={OneVoucherLogo} alt="" style={{ height: 28, width: "auto" }} />
								</GradientButton>
							</Col>
							<Col xs={12} md={4}>
								<GradientButton
									variant="greenYellow"
									onClick={() => setShowFlashPaymentModal(true)}
									disabled={flashPaymentDisabled}
									aria-label="Flash Bill Payment"
									style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
									className="mb-3"
								>
									<img src={FlashLogo} alt="" style={{ height: 28, width: "auto" }} />
								</GradientButton>
							</Col>
						</>
					) : (
						<Col xs={12} md={6} className="offset-md-3">
							<GradientButton
								title={completingPurchase ? "Complete Purchase..." : "Complete Purchase"}
								variant="greenYellow"
								onClick={handleCompletePurchase}
								disabled={completingPurchase}
								loading={completingPurchase}
								className="mb-3"
							/>
						</Col>
					)}
				</Row>
				<Row>
					<Col className="text-center">
						<GradientButton title="Cancel" variant="yellowOrange" onClick={() => props.onSubmit(false)} className="mt-3 col-md-6 mx-auto" />
					</Col>
				</Row>
			</Form>
			{!showDiscountControls && (
				<Row>
					<Col className="text-center">
						<button
							type="button"
							style={{ fontSize: 16 }}
							className="btn btn-link profile-action-link text-success text-decoration-underline p-0 mt-2"
							onClick={() => setShowDiscountControls(true)}
						>
							Apply Discount Code
						</button>
					</Col>
				</Row>
			)}
			{showDiscountControls && (
				<Row className="justify-content-center mt-3">
					<Col xs={12} md={6} className="d-flex flex-column">
						<Form.Control
							type="text"
							placeholder="Add Discount Code"
							value={voucherCode}
							onChange={handleVoucherCodeChange}
							className="mb-2"
						/>
						<GradientButton
							title="Apply Discount Code"
							variant="greenYellow"
							onClick={handleApplyVoucherCode}
							disabled={!voucherCode}
						/>
						{voucher && voucher.VoucherValue > 0 && (
							<div className="text-center">
								<p className="text-success font-weight-bold mb-1">
									Discount applied successfully! Value: R {voucher.VoucherValue.toFixed(2)}
								</p>
								<p className="font-weight-bold mb-0">New Amount Payable: R {itnAmount.toFixed(2)}</p>
							</div>
						)}
						{voucherCodeErrorMessage && <p className="text-danger fw-bold text-center mb-0">{voucherCodeErrorMessage}</p>}
					</Col>
				</Row>
			)}
			</div>
			<OneVoucherModal
				show={showOneVoucherModal}
				onClose={() => setShowOneVoucherModal(false)}
				category={props.category}
				product={props.product}
				voucher={voucher}
				amount={itnAmount}
				onSuccess={() => navigate("/Portal/Home")}
			/>
			<FlashAccountPaymentModal
				show={showFlashPaymentModal}
				onClose={() => setShowFlashPaymentModal(false)}
				category={props.category}
				product={props.product}
				amount={itnAmount}
				voucher={voucher}
			/>
		</React.Fragment>
	);
}
